export const getBlockItems = (state) => {
  return state.feature.allIds.map((id) => {
    return state.feature.byID[id];
  });
};
